export default __webpack_public_path__ + "images/logo-caddy.svg?2797cb00da69b03fc201ff15ef46af25";